<template>
  <div class="home-content-page-v">
    <div class="choose-data-show">
      <a href="javascript:;" v-for="(data_type, index) in data_types" :class="{'active-type': active_type === index}" @click="active_type = index">
        {{data_type}}
      </a>
    </div>
    <div class="data-one" v-if="active_type===0">
      <div class="table-content">
        <mii-table :datas="dataGridPrice" :table_style="2" :ths="ths_1" title="电价" scroll_table="true" :table_height="table_height"></mii-table>
      </div>
      <div class="chat-content">
        <div class="map-page" id="chart-grid_price">
        </div>
      </div>
    </div>
    <div class="data-one" v-if="active_type===1">
      <div class="table-content">
        <mii-table :datas="dataLoad" :table_style="2" :ths="ths_2" title="负荷" scroll_table="true" :table_height="table_height"></mii-table>
      </div>
      <div class="chat-content">
        <div class="map-page" id="chart-load">
        </div>
      </div>
    </div>
    <div class="data-one" v-if="active_type===2">
      <div class="table-content">
        <mii-table :datas="dataNewEng" :table_style="2" :ths="ths_3" title="光伏出力" scroll_table="true" :table_height="table_height"></mii-table>
      </div>
      <div class="chat-content">
        <div class="map-page" id="chart-new_eng">
        </div>
      </div>
    </div>
    <div class="data-one" v-if="active_type===3">
      <div class="table-content">
        <mii-table :datas="dataSteadyBattery" :table_style="2" :ths="ths_4" title="固定储能" scroll_table="true" :table_height="table_height"></mii-table>
      </div>
      <div class="chat-content">
        <div class="map-page" id="chart-steady-b">
        </div>
      </div>
    </div>
    <div class="data-one" v-if="active_type===4">
      <div class="table-content">
        <mii-table :datas="dataMoveBattery" :table_style="2" :ths="ths_5" title="移动储能" scroll_table="true" :table_height="table_height"></mii-table>
      </div>
      <div class="chat-content">
        <div class="map-page" id="chart-move-b">
        </div>
      </div>
    </div>
    <div style="display: none">
      {{sourceDataEle}}
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import MiiTable from '../../components_bit/MiiTable'
  import {
    initChatContinuousOption
  } from '../../eleChatOption'
  export default {
    components: {
      MiiTable
    },
    data () {
      return {
        active_type: -1,
        table_height: 24,
        data_types: ['电价', '负荷', '光伏出力', '固定储能', '移动储能'],
        chat_grid_price: null,
        chat_load: null,
        chat_new_eng: null,
        chat_1: null,
        chat_2: null,
        ths_1: [{
          label: 'id',
          key: 0
        },
        {
          label: '时间',
          key: 1
        },
        {
          label: '电价',
          key: 2
        },
        {
          label: '卖价',
          key: 3
        }],
        ths_2: [{
          label: '时间',
          key: 0
        },
        {
          label: '负荷',
          key: 1
        }],
        ths_3: [{
          label: 'id',
          key: 0
        },
        {
          label: '时间',
          key: 1
        },
        {
          label: '雨天',
          key: 2
        },
        {
          label: '晴天',
          key: 3
        }],
        ths_4: [{
          label: '电量',
          key: 0
        },
        {
          label: '功率下限',
          key: 1
        },
        {
          label: '功率上限',
          key: 2
        }],
        ths_5: [{
          label: '时间',
          key: 0
        },
        {
          label: '在网车辆数目',
          key: 1
        },
        {
          label: '新增初始能量',
          key: 2
        },
        {
          label: '储能下限',
          key: 3
        },
        {
          label: '储能上限',
          key: 4
        }]
      }
    },
    computed: {
      sourceDataEle: {
        get () {
          if (this.$store.getters.sourceDataEle) {
            let vm = this
            Vue.nextTick(function () {
              vm.active_type = (vm.active_type + 1) % 3
            })
          }
          return this.$store.getters.sourceDataEle
        }
      },
      eleStatus: {
        get () {
          return this.$store.getters.eleStatus
        }
      },
      dataGridPrice: {
        get () {
          return this.sourceDataEle.grid_price
        }
      },
      dataLoad: {
        get () {
          return this.sourceDataEle.load
        }
      },
      dataNewEng: {
        get () {
          return this.sourceDataEle.new_eng
        }
      },
      dataSteadyBattery: {
        get () {
          return this.sourceDataEle.Steady_battery
        }
      },
      dataMoveBattery: {
        get () {
          return this.sourceDataEle.Move_battery
        }
      }
    },
    methods: {
      initChatGridPrice () {
        this.chat_grid_price = window.echarts.init(document.getElementById('chart-grid_price'))
        let data = this.dataGridPrice
        if (data) {
          let chatData = {max: 0, xData: [], yData: [[], []], legend: ['电价', '卖价']}
          data.forEach(function (item) {
            chatData.max = chatData.max < item[2] ? item[2] : chatData.max
            chatData.xData.push(item[1])
            chatData.yData[0].push(item[2])
            chatData.yData[1].push(item[3])
          })
          this.chat_grid_price.setOption(initChatContinuousOption(chatData, true), true)
        }
      },
      initChatLoad () {
        this.chat_load = window.echarts.init(document.getElementById('chart-load'))
        let data = this.dataLoad
        if (data) {
          let chatData = {max: 0, xData: [], yData: [[]], legend: ['负荷']}
          data.forEach(function (item) {
            chatData.max = chatData.max < item[1] ? item[1] : chatData.max
            chatData.xData.push(item[0])
            chatData.yData[0].push(item[1])
          })
          this.chat_load.setOption(initChatContinuousOption(chatData), true)
        }
      },
      initChatNewEng () {
        this.chat_new_eng = window.echarts.init(document.getElementById('chart-new_eng'))
        let data = this.dataNewEng
        if (data) {
          let chatData = {max: 0, xData: [], yData: [[], []], legend: ['雨天', '晴天']}
          data.forEach(function (item) {
            chatData.max = chatData.max < item[3] ? item[3] : chatData.max
            chatData.xData.push(item[1])
            chatData.yData[0].push(item[2])
            chatData.yData[1].push(item[3])
          })
          this.chat_new_eng.setOption(initChatContinuousOption(chatData), true)
        }
      },
      initChatSteadyBattery () {
        this.chat_1 = window.echarts.init(document.getElementById('chart-steady-b'))
        let data = this.dataSteadyBattery
        if (data) {
          let chatData = {max: 0, xData: [], yData: [[], []], legend: ['功率下限', '功率上限']}
          data.forEach(function (item) {
            chatData.max = chatData.max < item[2] ? item[2] : chatData.max
            chatData.xData.push(item[0])
            chatData.yData[0].push(item[1])
            chatData.yData[1].push(item[2])
          })
          this.chat_1.setOption(initChatContinuousOption(chatData, false, true), true)
        }
      },
      initChatMoveBattery () {
        this.chat_2 = window.echarts.init(document.getElementById('chart-move-b'))
        let data = this.dataMoveBattery
        if (data) {
          let chatData = {max: 0, xData: [], yData: [[], [], []], legend: ['新增初始能量', '储能下限', '储能上限']}
          data.forEach(function (item) {
            chatData.max = chatData.max < item[3] ? item[3] : chatData.max
            chatData.xData.push(item[0])
            chatData.yData[0].push(item[2])
            chatData.yData[1].push(item[3])
            chatData.yData[2].push(item[4])
          })
          this.chat_2.setOption(initChatContinuousOption(chatData), true)
        }
      }
    },
    watch: {
      active_type (val, oldVal) {
        let vm = this
        Vue.nextTick(function () {
          if (val === 0) {
            vm.initChatGridPrice()
          } else if (val === 1) {
            vm.initChatLoad()
          } else if (val === 2) {
            vm.initChatNewEng()
          } else if (val === 3) {
            vm.initChatSteadyBattery()
          } else if (val === 4) {
            vm.initChatMoveBattery()
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .hide-content {
    display: none !important;
  }
  .table-content {
    flex: 1;
  }
  .chat-content {
    .content-shadow;
    margin: 0 1rem;
    border-radius: 1rem;
    background: #fff;
    width: 70%;
  }
  .choose-data-show {
    display: flex;
    align-self: center;
    width: 30%;
    margin-bottom: 1em;
    border-radius: 0.3em;
    padding: 0 0.5em;
    background: @bak-color-2;
    a {
      font-size: 0.8rem;
      line-height: 2.5;
      text-align: center;
      color: #fff;
      flex: 1;
    }
    a:hover {
      background: @bak-color-1;
    }
    .active-type {
      background: @bak-color-1;
      border-bottom: 3px solid #00ccff;
    }
  }
  .data-one {
    display: flex;
    height: 29rem;
  }
  .map-page {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// ele_source_data.vue?a9d04fb0